import { Model } from '../parents/model';

export class OrderModel extends Model {
  subResources = {};

  static ATTR_ID = 'id';
  static ATTR_CUSOTMER_ID = 'customer_id';
  static ATTR_PRICE = 'price';
  static ATTR_TAXED_PRICE = 'taxed_price';
  static ATTR_EMAIL = 'email';
  static ATTR_CLIENT_IP = 'client_ip';
  static ATTR_USER_AGENT = 'user_agent';
  static ATTR_ORDER_STATE_ID = 'order_state_id';
  static ATTR_CUSTOMER_NOTE = 'customer_note';
  static ATTR_WEIGHT = 'weight';
  static ATTR_SHIPPED_AT = 'shipped_at';
  static ATTR_CANCELLED_AT = 'cancelled_at';
  static ATTR_COMPLETED_AT = 'completed_at';
  static ATTR_HAS_SHIPPING_ADDRESS = 'has_shipping_address';
  static ATTR_PAID_AT = 'paid_at';
  static ATTR_CREATED_AT = 'created_at';
  static ATTR_UPDATED_AT = 'updated_at';
  static ATTR_CURRENCY_ID = 'currency_id';

  /**
   * Embeds
   */
  static EMBED_STATE = 'state';
  static EMBED_CUSTOMER_NAME = 'customer_name';
  static EMBED_SHIPPING = 'shipping';
  static EMBED_PAYMENT = 'payment';
  static EMBED_INVOICES = 'invoices';
  static EMBED_PARINGS = 'pairings';
  static EMBED_LATEST_CREDIT_ID = 'latest_credit_id';
  static EMBED_TAXED_ITEMS_PRICE = 'taxed_items_price';
  static EMBED_TAX_AMOUNT = 'tax_amount';
  static EMBED_ITEMS_COUNT = 'items_count';

  /**
   * Subresources
   */
  static SUB_SHIPPING_METHODS = 'shipping_methods';
  static SUB_PAYMENT_METHODS = 'payment_methods';
  static SUB_ITEMS = 'items';
  static SUB_ADDRESSES = 'addresses';
  static SUB_COMMENTS = 'comments';
  static SUB_DISCOUNTS = 'discounts';
  static SUB_DISCOUNT_ITEMS = 'discount_items';
  static SUB_CUSTOMER_ACCOUNTS = 'customer_accounts';

  get customerId() {
    return this.attributes[OrderModel.ATTR_CUSOTMER_ID];
  }

  get price() {
    return this.attributes[OrderModel.ATTR_PRICE];
  }

  get taxedPrice() {
    return this.attributes[OrderModel.ATTR_TAXED_PRICE];
  }

  get email() {
    return this.attributes[OrderModel.ATTR_EMAIL];
  }

  get clientIp() {
    return this.attributes[OrderModel.ATTR_CLIENT_IP];
  }

  get userAgent() {
    return this.attributes[OrderModel.ATTR_USER_AGENT];
  }

  get orderStateId() {
    return this.attributes[OrderModel.ATTR_ORDER_STATE_ID];
  }

  get customerNote() {
    return this.attributes[OrderModel.ATTR_CUSTOMER_NOTE];
  }

  get weight() {
    return this.attributes[OrderModel.ATTR_WEIGHT];
  }

  get shippedAt() {
    return this.attributes[OrderModel.ATTR_SHIPPED_AT];
  }

  get cancelledAt() {
    return this.attributes[OrderModel.ATTR_CANCELLED_AT];
  }

  get completedAt() {
    return this.attributes[OrderModel.ATTR_COMPLETED_AT];
  }

  get hasShippingAddress() {
    return this.attributes[OrderModel.ATTR_HAS_SHIPPING_ADDRESS];
  }

  get paidAt() {
    return this.attributes[OrderModel.ATTR_PAID_AT];
  }

  get createdAt() {
    return this.attributes[OrderModel.ATTR_CREATED_AT];
  }

  get createdAtFormatted() {
    return new Date(this.createdAt).toLocaleString('cs-CZ');
  }

  get updatedAt() {
    return this.attributes[OrderModel.ATTR_UPDATED_AT];
  }

  get currencyId() {
    return this.attributes[OrderModel.ATTR_CURRENCY_ID];
  }

  get state() {
    return this.embeds[OrderModel.EMBED_STATE];
  }

  get customerName() {
    return this.embeds[OrderModel.EMBED_CUSTOMER_NAME];
  }

  get shipping() {
    return this.embeds[OrderModel.EMBED_SHIPPING];
  }

  get payment() {
    return this.embeds[OrderModel.EMBED_PAYMENT];
  }

  get invoices() {
    return this.embeds[OrderModel.EMBED_INVOICES];
  }

  get pairings() {
    return this.embeds[OrderModel.EMBED_PARINGS];
  }

  get latestCreditId() {
    return this.embeds[OrderModel.EMBED_LATEST_CREDIT_ID];
  }

  get taxedItemsPrice() {
    return this.embeds[OrderModel.EMBED_TAXED_ITEMS_PRICE];
  }

  get taxAmount() {
    return this.embeds[OrderModel.EMBED_TAX_AMOUNT];
  }

  get itemsCount() {
    return this.embeds[OrderModel.EMBED_ITEMS_COUNT];
  }

  get items() {
    return this.subResources[OrderModel.SUB_ITEMS];
  }

  get addresses() {
    return this.subResources[OrderModel.SUB_ADDRESSES];
  }

  get discounts() {
    return this.subResources[OrderModel.SUB_DISCOUNTS];
  }

  get shippingMethods() {
    return this.subResources[OrderModel.SUB_SHIPPING_METHODS];
  }

  get paymentMethods() {
    return this.subResources[OrderModel.SUB_PAYMENT_METHODS];
  }

  get freeShippingAndPayment() {
    let freeShipping = false;

    if (!this.discounts) {
      return freeShipping;
    }

    this.discounts.forEach(discount => {
      if (discount.freeShipping) {
        freeShipping = true;
      }
    });

    return freeShipping;
  }

  get customerAccounts() {
    return this.subResources[OrderModel.SUB_CUSTOMER_ACCOUNTS];
  }

  /**
   * @param {Object} orderSubresource
   */
  extendOrder(orderSubresource) {
    this.subResources = { ...this.subResources, ...orderSubresource };
  }
}
